import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

export const fetchOrchestrationList = ({ workspaceId }) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      workspace_id: workspaceId,
    })
  };

  return postToApi('v1/api/orchestration/list', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrOrchestrationListFetcher = (queryParams) => {
  const [workspaceId] = queryParams;

  return fetchOrchestrationList({ workspaceId }).then(response => response.json());
}

export default fetchOrchestrationList;
